import React from 'react';
import { Route, useRoute } from 'wouter';
import './AppTool.css';

import AppToolRegex from './AppToolRegex.js';
import AppToolJson from './AppToolJson.js';
import AppToolSQL from './AppToolSQL.js';
import AppToolTime from './AppToolTime.js';
import AppToolString from './AppToolString.js';
import AppToolUrl from './AppToolUrl.js';
import AppToolPassword from './AppToolPassword.js';

// Tool list component
const ToolList = () => {
  const tools = [
    {
      id: 'regex',
      name: '正则工具',
      description: '正则调试',
      path: '#/tool/regex'
    },
    {
      id: 'json',
      name: 'JSON/YAML格式化',
      description: '支持base64后的json直接格式化',
      path: '#/tool/json'
    },
    {
      id: 'sql',
      name: 'SQL格式化',
      description: 'SQL格式化工具',
      path: '#/tool/sql'
    },
    {
      id: 'time',
      name: '时间戳转换',
      description: '自动解析各种格式的时间字符串，并格式化输出',
      path: '#/tool/time'
    },
    {
      id: 'string',
      name: '字符串转义',
      description: '对字符串进行转义和反转义',
      path: '#/tool/string'
    },
    {
      id: 'url',
      name: 'URL/Base64编码/解码',
      description: 'URL编码/解码和Base64编码/解码工具',
      path: '#/tool/decode_encode'
    },
    {
      id: 'password',
      name: '随机密码生成器',
      description: '生成安全的随机密码，支持多种配置选项',
      path: '#/tool/password'
    }
  ];

  return (
    <div id="tool_index">
      <div className="security-notice">
        以下都是纯前端实现的工具，本站不会收集任何数据!
      </div>
      <table>
        <thead>
          <tr>
            <td>工具</td>
            <td>说明</td>
          </tr>
        </thead>
        <tbody>
          {tools.map(tool => (
            <tr key={tool.id}>
              <td><a href={tool.path}>{tool.name}</a></td>
              <td>{tool.description}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Main AppTool component
const AppTool = () => {
  const [matchRegex] = useRoute('/tool/regex');
  const [matchJson] = useRoute('/tool/json');
  const [matchSql] = useRoute('/tool/sql');
  const [matchTime] = useRoute('/tool/time');
  const [matchString] = useRoute('/tool/string');
  const [matchUrl] = useRoute('/tool/decode_encode');
  const [matchPassword] = useRoute('/tool/password');

  if (matchRegex) {
    return <AppToolRegex />;
  }
  if (matchJson) {
    return <AppToolJson />;
  }
  if (matchSql) {
    return <AppToolSQL />;
  }
  if (matchTime) {
    return <AppToolTime />;
  }
  if (matchString) {
    return <AppToolString />;
  }
  if (matchUrl) {
    return <AppToolUrl />;
  }
  if (matchPassword) {
    return <AppToolPassword />;
  }

  return <ToolList />;
};

export default AppTool;